import type { IconProps } from './types';
import './icons.css';

export default function Paper({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 16}
      height={height || 17}
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-paper ${className || ''}`}
      fill="none"
    >
      <path
        d="M4 15.167h8c.736 0 1.333-.597 1.333-1.334v-6.78c0-.354-.14-.694-.39-.944L9.057 2.224c-.25-.25-.589-.39-.943-.39H4c-.736
        0-1.333.596-1.333 1.333v10.666c0 .737.597 1.334 1.333 1.334Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.667 2.167V6.5h4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
